<template>
  <div>
    <section class="xlrclh">
      <img
        class="top-img"
        src="../../assets/imgs/jinjiang/13/title-bg.png"
        alt=""
      />
      <div class="technological-process">
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-1.png"
            alt=""
          />
          <div class="content">在校或毕业未超过3年的普通高校全日制大学生。</div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/7/title-2.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）企业法人或持股30%以上的股东；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）租金减免政策需入驻锦江区各类青年创业平台方可申报。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/7/title-3.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）创业企业（团队）入驻评审得分在95分及以上的，可提供3年租金减免支持；得分在90—94分的，可提供2年租金减免支持；得分在85-89分的，可提供1年租金减免支持。低于85分的不提供租金减免政策；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）创业企业（团队）申报贷款支持政策，需入驻锦江区青年创业平台。入驻评审得分在95分及以上的，可提供3年全额利息补贴支持；得分在90—94分的，可提供2年全额利息补贴支持；得分在85-89分的可提供1年全额利息补贴支持。低于85分的不提供贷款支持政策。补贴金额按当年LPR标准计算，补贴总金额不超过50万元；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）获得省级及以上创新创业大赛奖励且一年内在锦江区设立企业的优秀创业团队，获得一等奖的，给予10万元创业支持；获得二等奖的，给予8万元创业支持；获得三等奖的，给予5万元创业支持。支持金额不高于企业实缴注册资本金额。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/3/title-4.png"
            alt=""
          />
          <div
            class="content"
            style="
              font-size: 0.3rem;
              color: #333333;
              font-weight: 600;
              display: flex;
            "
          >
            <div class="circle"></div>
            （一）租金减免政策申报需提交以下材料：
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区青年创业平台租金减免政策申报表》（附件1）；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）申报企业的营业执照、税务登记证复印件，纳税证明、社保缴纳证明、获奖情况等；
            </div>
          </div>
          <div class="content">
            <div class="font">（三）与锦江区青年创业平台签订的租赁合同；</div>
          </div>
          <div class="content">
            <div class="font">（四）创业企业的简介以及核心业务项目计划书；</div>
          </div>
          <div class="content">
            <div class="font">
              （五）普通高校全日制大学生作为申报企业的法人或股东的身份证明材料，及毕业证、学位证、学信网学籍证明等；
            </div>
          </div>
          <div class="content">
            <div class="font">（六）其他需要补充提交的材料。</div>
          </div>
          <div
            class="content"
            style="
              font-size: 0.3rem;
              color: #333333;
              font-weight: 600;
              display: flex;
            "
          >
            <div class="circle"></div>
            （二）创业贷款支持政策申报需提交以下材料：
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区青年创业贷款申报表》（附件2）；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （二）企业的统一社会信用代码证复印件，年度纳税证明、社保缴纳证明、征信报告等；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （三）企业法人身份证复印件；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （四）普通高校全日制大学生作为申报企业的法人或股东的身份证明材料，及毕业证书、学位证书、学信网学籍证明等材料；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （五）企业简介以及核心业务的项目计划书；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （六）贷款合同复印件；
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （七）其他需要补充提交的材料。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-5.png"
            alt=""
          />
          <div class="content" style="display: flex">
            <div class="circle"></div>
            <div>
              <div
                style="
                  font-weight: 600;
                  font-size: 0.3rem;
                  margin-bottom: 0.1rem;
                "
              >
                租金减免支持政策
              </div>
              <div>
                租金减免支持政策由创业企业（团队）向入驻的创业平台提出申报并提交相应材料，平台及时收集汇总报送至所属街道
              </div>
            </div>
          </div>
          <div class="content" style="display: flex">
            <div class="circle"></div>
            <div>
              <div
                style="
                  font-weight: 600;
                  font-size: 0.3rem;
                  margin-bottom: 0.1rem;
                "
              >
                创业贷款支持政策
              </div>
              <div>
                创业贷款支持政策由各创业企业向团区委提交申请并提交相应材料
              </div>
            </div>
          </div>
        </div>
        <div class="contact">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-6.png"
            alt=""
          />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-86667984">028-86667984</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              团锦江区委
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/70/code.png" />
          <img class="text" src="../assets/imgs/70/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 50%;
  border: 0.08rem solid #ff6d60;
  flex-shrink: 0;
  margin-right: 0.1rem;
  margin-top: 0.05rem;
}
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 100%;
    height: auto;
  }
  .technological-process {
    transform: translateY(-2.5rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.35rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.3rem 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.95rem auto 0;
        padding: 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.15rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          .title {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .item {
            margin-top: 0.3rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/jinjiang/1/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 1.72rem;
      }
    }
  }
}
</style>
